
export class ScheduleSummary {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    public Id: number;
    public Schedule: string;
}